import { CollectionHeroBanner as HeroBanner } from "@bared/ui";
import Container from "@components/Atomic/Container/Container";
import { styledWithInvalidProps } from "@components/Styled/StyledWithInvalidProps";
import React from "react";
import tw, { css } from "twin.macro";
import CollectionHeroBannerSizeFilters from "./CollectionHeroBannerSizeFilters";
import { withCollectionHeroBanner } from "./withCollectionHeroBanner";

const Overlay = styledWithInvalidProps("div")(({ rgb }) => [
  tw`absolute z-10 w-full h-full`,
  rgb ? `background-color: rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})` : null,
]);

const Wrapper = styledWithInvalidProps("div")(({ textColor }) => [
  "lightest" === textColor
    ? css`
        a:hover {
          ${tw`text-white`}
        }
      `
    : css`
        a:hover {
          ${tw`text-primary`}
        }
      `,
]);

const CollectionHeroBanner = withCollectionHeroBanner(
  ({
    layout,
    styles,
    collectionTitle,
    desktopBanner,
    mobileBanner,
    location,
    ...props
  }) => {
    return (
      <Container className="relative" styles={styles}>
        {layout === "sizeFilterContent" && (
          <CollectionHeroBannerSizeFilters
            collectionTitle={collectionTitle}
            location={location}
            desktopBanner={desktopBanner}
            mobileBanner={mobileBanner}
            {...props}
          />
        )}
        {layout === "bannerContent" && (
          <Wrapper textColor={props.bannerTextColor}>
            <Overlay rgb={props.bannerBackgroundColor?.rgb} />
            <HeroBanner
              desktopBanner={desktopBanner}
              mobileBanner={mobileBanner}
              desktopImage={props.desktopImage}
              mobileImage={props.mobileImage}
              desktopVideoUrl={props.desktopVideo?.url}
              mobileVideoUrl={props.mobileVideo?.url}
              bannerTextColor={props?.bannerTextColor}
              children={props.children}
            />
          </Wrapper>
        )}
      </Container>
    );
  },
);

export default CollectionHeroBanner;
